import axios from 'axios';

const appClient = axios.create({
  baseURL: process.env.VUE_APP_APP_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'App-Os': 'web',
  }
});

appClient.interceptors.request.use(
  config => {
    // Add any request-specific logic here if needed
    const token = localStorage.getItem('castingup_app_token') || 'JSc8Z0fZi4vtNp3Jw3dnBuhnBVI3SUaK';
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    // Handle request errors
    return Promise.reject(error);
  }
);

export default appClient;
